<template>
  <div class="text-cards-message">
    <div class="warpper">
      <div>
        <dl v-for="(r, index) of content.cards" :key="index">
          <br>
          <div class="rich_card float-right">
            <div class="card_single">
              <div class="content" >
                <div style="min-height: 188px;background-color: #fff;">

                
                <carousel v-if="imgList.length > 0" :nav="false" :margin-right="false" :mouseDrag="false" :dots="false" :loop="false"
                  :auto-width="true" :rtl="false" class="rich_carousel" >
                  <template v-if="imgList.length > 1" slot="prev"><span class="prev">prev</span></template>
                  <dl v-for="(r, index) of imgList" :key="index">
                    <dd>
                      <div class="card_single" style="border-radius: 0;">
                        <div class="img" v-if="r && r !== ''">
                          <a>
                            <img class="img-card" :src="r" alt="圖片說明">
                          </a>
                        </div>
                      </div>
                    </dd>
                  </dl>
                  <template v-if="imgList.length > 1" slot="next"><span class="next">next</span></template>
                </carousel>
              </div>
                <div class="info">
                  <p v-html="r.text" />
                </div>
                <div class="rich-btn">
                  <button v-for="(b, index) of r.buttons" :key="index" @click="openTargetUrl(b.payload, b.actionType)">
                    <a v-if="b.actionType == 'text'">{{ b.title }}</a>
                    <a v-if="b.actionType == 'url'" :href="b.payload" style="color:#000;text-decoration: none"
                      target="_blank">{{
                        b.title }}</a>
                    <a v-if="b.actionType == 'email'" style="color:#000;text-decoration: none" :href="b.payload"
                      target="_blank">{{
                        b.title }}</a>
                    <a v-if="b.actionType == 'phone'" style="color:#000;text-decoration: none" :href="b.payload">{{
                      b.title }}</a>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
import carousel from "v-owl-carousel"
export default {
  components: {
    carousel,
  },
  props: {
    message: {
      type: Object,
      required: true,
      default: () => { }
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  created() {
    const contentData = JSON.parse(this.message.msgJson)
    for (let i = 0; i < contentData.cards.length; i++) {
      // console.log(contentData.cards[i].text)
      // 處理 超連結 和 email
      // this.$set(contentData.cards[i], 'text', JSON.parse(this.message.msgJson).cards[i].text)
      // 處理按鈕的 email 
      for (let j = 0; j < contentData.cards[i].buttons.length; j++) {
        if (contentData.cards[i].buttons[j].actionType === 'email') {
          contentData.cards[i].buttons[j].payload = 'mailto:' +
            contentData.cards[i].buttons[j].payload
        } else if (contentData.cards[i].buttons[j].actionType === 'phone') {
          contentData.cards[i].buttons[j].payload = 'tel:' +
            contentData.cards[i].buttons[j].payload
        }
      }
    }
    this.content = contentData
  },
  mounted() {
    const params = {
      limit: this.content.params.limit || 1
    }
    if (this.content.params.cate) {
      params.cate = this.content.params.cate
    }
    if (this.content.params.sub) {
      params.sub = this.content.params.sub
    }
    if (this.content.params.tag) {
      params.tag = this.content.params.tag
    }

    // 改接正式 API 20250421 wilson
    this.axios.get('https://health.udn.com/api/chatbot/image', {params})
      .then(response => {
        this.imgList = response.data[0].images
        // 改抓圖片標題 20250423 wilson
        this.content.cards[0].text = response.data[0].title
        $(document).ready(function () {

          $(".img-card").on("click", function (event) {
            if (this.showingImage) {
              return
            }
            this.showingImage = true
            let element = document.getElementById("sc-message-list")
            let width = element.offsetWidth
            let height = element.offsetHeight
            let img = $(this)
            if (!img[0].getBoundingClientRect) return // 防止 offset 錯誤
            let rect = img[0].getBoundingClientRect()
            let offsetTop = rect.top + window.scrollY
            let offsetLeft = rect.left + window.scrollX
            let clone = img.clone().appendTo("body")
            let maxWidth = width > 800 ? 800 : width
            let scaleFactor = maxWidth / (img.width() + 6)
            let appWidth = window.outerWidth < 450
            // 創建黑色遮罩
            let overlay = $('<div></div>').appendTo("#sc-message-list")
            overlay.css({
              position: "fixed",
              top: appWidth ? "0px" : "20px",
              left: appWidth ? "0px" : "20px",
              width: width,
              height: appWidth ? window.outerHeight + 'px' : height + 135 + 'px',
              borderRadius: "8px",
              background: "rgba(0, 0, 0, 0.6)",
              zIndex: 100,

              display: "none"
            }).fadeIn(300)

            clone.css({
              position: "absolute",
              top: offsetTop,
              left: offsetLeft,
              width: img.width(),
              height: img.height(),
              zIndex: 9999,
              transformOrigin: "center center",
              transition: "transform 0.3s ease-in-out, top 0.3s ease-in-out, left 0.3s ease-in-out",
              objectFit: "contain"
            })

            setTimeout(() => {
              clone.css({
                transform: `translate(-50%, -50%) scale(${scaleFactor})`,
                top: "50%",
                left: "50%",
                maxHeight: "60%",
              })
            }, 10)

            clone.on("click", () => {
              this.showingImage = false
              clone.css({
                transform: "scale(1)",
                top: offsetTop,
                left: offsetLeft
              })
              overlay.fadeOut(300, function () {
                $(this).remove()
              })
              setTimeout(() => clone.remove(), 500)
            })
            overlay.on("click", () => {
              this.showingImage = false
              clone.css({
                transform: "scale(1)",
                top: offsetTop,
                left: offsetLeft
              })
              overlay.fadeOut(300, function () {
                $(this).remove()
              })
              setTimeout(() => clone.remove(), 500)
            })
          })
        })
      })
      .catch(error => {
        console.log(error)
      })


  },
  data() {
    return {
      content: null,
      showingImage: false,
      imgList: []

    }
  },
  computed: {

    direction() {
      if ('direction' in JSON.parse(this.message.msgJson)) {
        // console.log('有此參數，採用設定:' + JSON.parse(this.message.msgJson).direction)
        return JSON.parse(this.message.msgJson).direction
      } else {
        // console.log('無此參數，預設橫向')
        return 'h'
      }
    },
    contentCount() {
      // console.log(JSON.parse(this.message.msgJson))
      const count = JSON.parse(this.message.msgJson).cards.length
      return count
    }
  },
  methods: {
    openTargetUrl(payload, actionType) {

      if (actionType == 'text') {
        // alert('1')
        this.$emit("tag-clicked", payload)
      }

    },
  }
}
</script>

<style scoped>
@import "./styles/carouselCardsMessage.css";
@import "./styles/rich_carousel.css";
</style>



// WEBPACK FOOTER //
// src/components/beautiful-chat/CarouselMessageCard.vue